import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useInfoStore } from '../../../store/userInfo';
import { useOrderStore } from '../../../store/order';
import { Box, ButtonBase, CircularProgress, IconButton, List, ListItem, Modal, Stack, Typography } from '@mui/material';
import { checkRequest, getCheckBill } from '../../../services/order.service';
// import close_w from '../../../assets/images/close_w.svg';
import { isBrowser } from 'react-device-detect';
import { iCheckOrderList, IModifier, IModifierGroup, IOrderItem, IOrderModifiers } from '../../../types/menu';
import { TurnLeft } from '@mui/icons-material';
import { logger } from '../../../utils/logger';

const LazyPicture = styled(LazyLoadImage)`
  object-fit: cover;
  width: ${({ width }) => (width ? `${width}rem` : "100%")};
  height: ${({ width }) => (width ? `${width}rem` : "100%")};

  &.lazy-load-image-background.opacity {
    background-image: none !important;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &.lazy-load-image-background.opacity.lazy-load-image-loaded {
    opacity: 1;
  }
`;

export enum OrderListMode {
  ORDER_LIST = 'orderList',
  DINING_TIME_ENDED = 'diningTimeEnded'
}

const CheckOrderList: React.FC<iCheckOrderList> = ({ isOpen, mode }) => {
	const {currentLng, userInfo, tableInfo} = useInfoStore();
	const { orderList, openOrderList, setOrderList, setOpenOrderList, setOpenCollect, setCollectInfo} = useOrderStore();
	// const { height } = useWindowDimensions();
  const storeId = userInfo?.storeId;
  const { t, i18n } = useTranslation([`${storeId}`,'translation'  ]);
  const [, setShowSnack] = useState(false)
  const [, setMode] = useState(0);
  // const [open, setOpen] = useState(false)
  const [renderContent, setRenderContent] = useState(false);

  useEffect(() => {
    if (mode === OrderListMode.DINING_TIME_ENDED) {
      loadOrder()
    }
  }, [mode]);

  const loadOrder = async () => {
    await getCheckBill(tableInfo.id).then(
      (res) => {
        if (res.status === 200 || res.status === 201) {
          logger.debug(res.data);
          setOrderList(res.data);
        }
      },
      (error) => {
        logger.error("error", error);
      }
    );
  }

  const hideDialog = () => { 
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    // setOpen(false)
    setOpenOrderList(false);
  }
  const handleCheckRequest = async (amount: any) => {
    // resetOrderCart()
    setCollectInfo(Object.assign({amount: amount}))
    // setOpenOrderList(false);
    // dispatch(setCollectState(true))

    await checkRequest(tableInfo.id).then(
      (res: { status: number; data: any; }) => {
        if(res.status === 200 || res.status === 201) {
          logger.debug(res.data);
          setMode(5)
          setShowSnack(true)

          logger.debug('ask for the check')
          setOpenOrderList(false)
          setOpenCollect(true)

    //       dispatch(setCollectState(true))
        }
      },
      () => {
        
      }
    )
  }

  const renderModifiers = (orderModifiers: IOrderModifiers[], level = 0) => {
      logger.debug(`Rendering level ${level} modifiers:`, orderModifiers);
      return orderModifiers.map((orderModifier: IOrderModifiers, idx: number) => (
        <Box>
          <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', height: '2.7rem', pl: `${level * 2.0}rem`}}>
             {level !== 0 && <TurnLeft sx={{transform: "rotate(180deg)"}}/>}
            <Typography sx={{flex: 1, fontSize: '1.8rem', fontStyle: 'normal', fontWeight: '400', lineHeight: 'normal', letterSpacing: '-.018rem', color:'#F72E13'}}>{orderModifier.modifierId ? t(`${storeId}:optionNames.${orderModifier.modifierId}.${currentLng}`): orderModifier.modifierName}</Typography>
            <Typography sx={{width: '4.0rem', fontSize: '1.8rem', fontStyle: 'normal', fontWeight: '500', lineHeight: 'normal', textAlign: 'right', color:'#F72E13'}} >x{orderModifier.quantity}</Typography>
            <Typography sx={{width: '8.5rem', fontSize: '1.8rem', fontStyle: 'normal', fontWeight: '500', lineHeight: 'normal', textAlign: 'right', color:'#F72E13'}}>${(orderModifier.modifierPrice/100).toFixed(2)}</Typography>
          </Box>
          {orderModifier.orderModifiers && renderModifiers(orderModifier.orderModifiers, level + 1)}
        </Box>
      ))
    };

  return (
			 <Modal
          keepMounted
          disableScrollLock
          disableEnforceFocus
          // hideBackdrop
          open={isOpen}
          onClose={hideDialog}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          sx={{ //You can copy the code below in your theme
            background: 'rgba(0,0,0,0.5)',
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent' // Try to remove this to see the result
            }
          }}
        >
          <Box sx={modal}>
            <Box sx={{width: '100%', height: '11.2rem', padding: '2.0rem 2.0rem', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.0rem', backgroundColor: '#f00', borderRadius: '1.5rem 1.5rem 0rem 0rem'}}>
              {mode === OrderListMode.ORDER_LIST ? (
                <>
                  <Typography sx={{textAlign: 'center', fontSize: '3.0rem', fontStyle: 'normal', fontWeight: '900', lineHeight: '150%', letterSpacing: '.15rem', color: '#fff'}}>THANK YOU</Typography>
                  <Typography sx={{textAlign: 'center', fontSize: '1.8rem', fontStyle: 'normal', fontWeight: '500', lineHeight: '150%', color: '#fff', textWrap: 'nowrap'}}>We hope you enjoy your purchase</Typography>
                </>
              ):(
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
                  <Typography sx={{textAlign: 'center', fontSize: '3.2rem', fontStyle: 'normal', fontWeight: '600', lineHeight: '3.8rem', letterSpacing: '-.32px', color: '#fff'}}>Thanks for dining with us.</Typography>
                  {/* <Typography sx={{textAlign: 'center', fontSize: '1.6rem', fontStyle: 'normal', fontWeight: '500', lineHeight: '2.0rem', color: '#fff', textWrap: 'nowrap'}}>Please wait a moment. Thanks for dining with us.</Typography> */}
                </Box>
              )}
             </Box>
            {mode === OrderListMode.ORDER_LIST && <div className="touch-area" style={{position: 'absolute',right: '3.0rem',top: '1.4rem',}}  onClick={hideDialog}> 
              <IconButton
                aria-label="close"
              >
                <LazyPicture sx={{width: '3rem', height: '3rem'}}
                  src={process.env.PUBLIC_URL+'/assets/images/close_w.svg'}
                  alt="close"
                />
              </IconButton>
            </div>}
            <Stack sx={{ padding: '2.5rem 5rem', alignItems: 'flex-start'}}>
              <Box sx={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-between'}}>
                <Typography sx={[{fontSize: '2.6rem', fontWeight: '800', fontStyle: 'normal', lineHeight: 'normal', color: '#000'}]}>ORDER HISTORY</Typography>
                <Box sx={{display: 'flex', flexDirection: 'row', height: '3.9rem', padding: '.7rem 1.7rem', alignItems: 'center', gap: '2.0rem', borderRadius: '3.0rem', background:'#000'}}>
                  <Typography sx={[{fontSize: '1.8rem', fontWeight: '500', fontStyle: 'normal', color: '#fff'}]}>Table No.</Typography>
                  <Typography sx={[{width: '10.0rem', fontSize: '1.8rem', fontWeight: '700', fontStyle: 'normal', textAlign: 'right', color: '#fff'}]}>{tableInfo.tableName}</Typography>
                </Box>
              </Box>
              {orderList.loading ? (
                <Box sx={{ display: 'flex', width: '100%', height: '40rem', justifyContent: 'center', alignItems: 'center' }}>
                  <CircularProgress />
                </Box>
              ) : (
                <List style={{ overflow: 'overlay', overflowX: 'hidden', height: '40rem', width: '100%', justifyContent: 'flex-start',  paddingTop: '2.0rem' }} >
                  {Object.keys(orderList).length === 0 || orderList.orderItems === undefined ? <></>:
                    orderList.orderItems.map((item: IOrderItem, idx: number) => {
                      return (<ListItem key={idx} sx={{p: 0 }}>
                          <Box sx={{ mb: '2.0rem', width: '100%', px: '1rem'}}>
                            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: '6.4rem'}}>
                              <Typography sx={{width: '50%', fontSize: '2.0rem', fontStyle: 'normal', fontWeight: '600', lineHeight: 'normal', letterSpacing: '-.02rem'}} >{item.itemId ? t(`${storeId}:itemNames.${item.itemId}.${currentLng}`): item.itemName}</Typography>
                              <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center'}}>
                                <Typography sx={{width: '4.0rem', fontSize: '2.0rem', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', textAlign: 'right'}} >x{item.quantity}</Typography>
                                <Typography sx={{width: '8.5rem', fontSize: '2.0rem', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', textAlign: 'right'}} >${(item.itemPrice/100).toFixed(2)}</Typography>
                              </Box>
                            </Box>
                            <Box sx={{ mt: '1.0rem',}}>
                              { item.orderModifiers.length !==0 && renderModifiers(item.orderModifiers)}
                            </Box>
                            {item.specialRequest !== ""?
                            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', mt: '1.6rem'}}>
                              <img style={{width: '2.7rem', height: '2.7rem'}}src={process.env.PUBLIC_URL+'/assets/images/notepad.svg'} alt='notepad' />
                              <Typography sx={{width: '57.3rem', display: 'inline-block', whiteSpace: 'nowrap', overflow: 'auto', overflowY: 'hidden', fontSize: '1.8rem', fontWeight: '400',
                                letterSpacing: '-.018rem', height: '4.0rem', padding: '.4rem .5rem'
                              }}>
                                {item.specialRequest}
                              </Typography>
                            </Box> : <></>}
                            <Box style={{ borderWidth: 1, borderStyle: 'solid', borderColor: '#000', marginTop: '2.0rem'}} />
                          </Box>
                    </ListItem>)
                    })
                  }
                  </List>
                )}
                <Box style={{ width: '100%' }} >
                  <Box sx={{borderTopWidth: '3px', borderStyle: 'solid', color: '#000'}} />
                  <Box sx={{mt: '1.5rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                  <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', width: '100%' }}>
                    <Typography sx={{ color: '#000', fontSize: '2.6rem', fontWeight: '700', fontStyle: 'normal', display: 'flex', alignItems: 'center' }}>
                      Subtotal
                      <span style={{ color: '#F72E13', fontSize: '1.6rem', fontWeight: '600', fontStyle: 'normal', marginLeft: '1rem' }}>
                        (Tax not included in the price)
                      </span>
                    </Typography>
                  </Box>
                    <Typography sx={{color: '#000', fontSize: '2.6rem', fontWeight: '700', fontStyle: 'normal', textAlign: 'right'}}>${orderList.totalAmount ? (orderList.totalAmount/100).toFixed(2) : "0.00 "} </Typography>
                  </Box>
                  <Box >
                    <Typography sx={{lineHeight: '150%', height: '4.0rem', letterSpacing: '-.0195rem', color: '#000', fontSize: '1.3rem', fontWeight: '500', fontStyle: 'normal'}}>{t(`translation:message.disclaimer.${currentLng}`)}</Typography>
                  </Box>
                  {mode === OrderListMode.ORDER_LIST && <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: '3.0rem'}} >
                    <ButtonBase 
                      onClick={() => handleCheckRequest(orderList.totalAmount)} 
                      disabled={Object.keys(orderList).length === 0 || orderList.orderItems === undefined}
                      sx={{
                        width: 'auto', 
                        flex: '0 0 auto', 
                        flexWrap: 'nowrap',  
                        height: '5.0rem', 
                        padding: '.4rem 3.3rem', 
                        background: Object.keys(orderList).length === 0 || orderList.orderItems === undefined ? '#CCCCCC' : '#F72E13', 
                        borderRadius: '3.0rem',
                        '&:disabled': {
                          cursor: 'not-allowed',
                          opacity: 0.7
                        }
                      }}
                    >
                      <Typography sx={{fontSize: '2.6rem', fontStyle: 'normal', fontWeight: '600', lineHeight: '150%', color:'#fff', textAlign: 'center'}} >Ask for the Check</Typography>
                    </ButtonBase>
                  </Box>}
                </Box>

            </Stack>
          </Box>
        </Modal>
  );
}

const modal = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  flex: 1,
  maxHeight: '100%',
  bgcolor: 'background.paper',
  // border: '2rem solid #fff',
	borderRadius: '1.5rem',
  boxShadow: '0rem 0rem 50rem 0rem rgba(0, 0, 0, 0.40)'

};

export default CheckOrderList;
